import React, { useState, forwardRef, useImperativeHandle } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import classNames from "./../../utils/classnames";

const QuestionBlock = forwardRef(function QuestionBlock(
  { title, children },
  ref,
) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  // Expose the toggleOpen function to parent components
  useImperativeHandle(ref, () => ({
    toggleOpen,
  }));

  return (
    <div className="py-3">
      <dt className="text-lg">
        <button
          type="button"
          className="flex items-start justify-between w-full text-left"
          onClick={toggleOpen}
        >
          <span className="font-medium" itemProp="name">
            {title}
          </span>
          <span className="flex items-center ml-6 h-7">
            <ChevronDownIcon
              className={classNames(
                "w-6 h-6 transition-transform duration-300 ease-in-out rotate-0 text-primary",
                isOpen && "rotate-180",
              )}
            />
          </span>
        </button>
      </dt>
      <dd className={classNames("pr-12 mt-3 ml-3", !isOpen && "hidden")}>
        <div className="py-3" itemProp="text">
          {children}
        </div>
      </dd>
    </div>
  );
});

export default QuestionBlock;
